<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-bell"></i>
          Log
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WEBCastle</a>
        </li>
        <li class="separator">
          <i class="fa fa-angle-right"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Log</a>
        </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <div v-else>
      <b-row>
        <b-col lg="12" xl="12">
          <b-card>
            <b-row>
              <b-col>
                <strong>Log Detail ({{ model.id }})</strong>
                <span class="float-right">Date : {{model.created_at | datetime}}</span>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col style="border-left: 1px solid #dcdcdc;">
                <h4>Client Information</h4>
                <hr>
                <div>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_remote_addr" v-b-tooltip.hover>Attacker: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover v-if="model">
                        <b-link v-if="id" href="javascript:void(0)" @click="copy(model.remote_addr)" v-b-tooltip.hover title="Click to copy">
                          {{model.remote_addr ? model.remote_addr : '-'}}
                        </b-link>
                        <span v-else>
                          {{model.remote_addr ? model.remote_addr : '-'}}
                        </span>
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_remote_addr" v-b-tooltip.hover>
                        XFF:
                        <span class="text-info" v-b-tooltip.hover.right="'XFF: Shows X-Forwarded-For data if a proxy is set'">
                          <i style='cursor: pointer;' @click="info_xff = true" class="fa fa-question-circle"></i>
                        </span>
                      </label>
                    </b-col>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover v-if="model">
                        {{ model.xff ? model.xff : '-' }}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_remote_addr" v-b-tooltip.hover>Country: </label>
                    </b-col>
                    <b-col>

                      <label for="ph_remote_addr" v-b-tooltip.hover>
                        <span v-if="model.country" class="flag-icon" :class="set_flag(model.country)"></span>
                        {{model.country ? model.country : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_protocol" v-b-tooltip.hover>Protocol: </label>
                    </b-col>
                    <b-col>

                      <label for="ph_protocol" v-b-tooltip.hover>
                        {{model.protocol ? model.protocol : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_port" v-b-tooltip.hover>Source port: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_port" v-b-tooltip.hover>
                        {{model.client_port ? model.client_port : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_method" v-b-tooltip.hover>Method: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_method" v-b-tooltip.hover>
                        {{model.method ? model.method : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_request" v-b-tooltip.hover>Request(Byte): </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_request" v-b-tooltip.hover>
                        {{model.request_size ? model.request_size : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_response" v-b-tooltip.hover>Response(Byte): </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_response" v-b-tooltip.hover>
                        {{model.response_size ? model.response_size : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
              <b-col style="border-left: 1px solid #dcdcdc;">
                <h4>Server Information</h4>
                <hr>
                <div>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_host" v-b-tooltip.hover>Host(Domain:)</label>
                    </b-col>
                    <b-col>
                      <label for="ph_host" v-b-tooltip.hover >{{model.host}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_host" v-b-tooltip.hover>Destination Port:</label>
                    </b-col>
                    <b-col>
                      -
                      <!-- <label for="ph_host" v-b-tooltip.hover>{{model.host}}</label> -->
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>Victim:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model">{{model.target}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>Public:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.ip_addr_public ? model.agent.ip_addr_public : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>Private:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.ip_addr_private ? model.agent.ip_addr_private : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>WAS:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.iwaf_type ? model.agent.iwaf_type : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>OS:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.os_type ? model.agent.os_type : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>host:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.host ? model.agent.host : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row v-if="model.agent && model.agent.nickname != model.agent.host">
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>Name:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.nickname ? model.agent.nickname : '-'}}</label>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col>
                      <label for="ph_uri" v-b-tooltip.hover>
                        URI <small>:</small>
                        <b-button v-if="model.uri.length > 100" size="sm" @click="view_split_uri = !view_split_uri" variant="info">
                          {{view_split_uri ? 'split' : 'origin'}} view
                        </b-button>
                      </label>
                    </b-col>
                    <b-col>
                      <pre v-if="view_split_uri" for="ph_uri" v-b-tooltip.hover>{{model.uri}}</pre>
                      <pre v-else>{{split_uri(model.uri || '')}}</pre>
                    </b-col>
                  </b-row> -->

                </div>
              </b-col>
              <b-col md="6" style="border-left: 1px solid #dcdcdc;">
                <h4>
                  Threat Information
                  <Bell v-if="model.message && model.message.messages && model.message.messages.length > 1" style="display: inline-block" :size="20" :count="model.message.messages.length" />
                </h4>

                <hr>
                <div>
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" for="ph_response">Response(Action):</label>
                    </b-col>
                    <b-col>
                      <b-badge v-if="model.is_block && this.model.block_cnt > 0" variant="danger">BlockMode</b-badge>
                      <b-badge v-else variant="warning">DetectMode</b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="cursor:pointer" md="3">
                      <label for="ph_response" class="font-weight-bold">Risk:</label>
                      <span class="text-info" v-b-tooltip.hover title="If multiple logs exist, the most dangerous one is displayed Undefined is marked with a 'lower' risk">
                        <i class="fa fa-question-circle"></i>
                      </span>
                    </b-col>
                    <b-col>
                      <b-badge :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(model.severity, 'variant')">
                        {{codes.WAF_SEVERITY_TO_DESC_EASY(model.severity, 'EN')}}
                      </b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" v-b-tooltip.hover>Policy ID:</label>
                      <span class="text-info" v-b-tooltip.hover title="Displays the specified policy number For user policies, it is set flexibly depending on user settings (from 8,000,000 to 8,999,999)">
                        <i class="fa fa-question-circle"></i>
                      </span>
                    </b-col>
                    <b-col>
                      <b-link v-if="id" href="javascript:void(0)" @click="() => quick_search(model.m_id, model)" v-b-tooltip.hover title="If it is not a user policy, you can search for the policy directly on the Agents page Click here">
                        {{ model.m_id ? model.m_id : '-' }}
                      </b-link>
                      <span v-else>
                        {{ model.m_id ? model.m_id : '-' }}
                      </span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label v-b-tooltip.hover class="font-weight-bold">Policy Name:</label>
                    </b-col>
                    <b-col>
                      {{ policy_domain() ? policy_domain() : '-' }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label v-b-tooltip.hover>
                        <label class="font-weight-bold">Message:</label>
                      </label>
                    </b-col>
                    <b-col>
                      <strong>{{ model.title_i18n ? (temp_i18n[model.title_i18n['EN'].desc] ? temp_i18n[model.title_i18n['EN'].desc] : model.title_i18n['EN'].desc) : (model.title ? model.title : i18nmsg) }}</strong>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col>
                      <label v-b-tooltip.hover>CVE</label>
                    </b-col>
                    <b-col>
                      {{ '-' }}
                    </b-col>
                  </b-row> -->
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" v-b-tooltip.hover>Tags:</label>
                    </b-col>
                    <b-col>
                      <span v-for="(x, index) in tags()" v-bind:key="index">
                        {{ x || '-' }} <br>
                      </span>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="parser_request">
              <b-col md="12">
                <b-form-group>
                  <b>
                    <label for="ph_request" v-b-tooltip.hover>
                      Request<small>:</small>
                    </label>
                    <b-button size="sm" @click="view_split_request = !view_split_request" variant="info">
                      {{view_split_uri ? 'split' : 'origin'}} view
                    </b-button>
                  </b>
                  <pre class="bg-secondary" v-if="view_split_request" for="ph_uri" v-b-tooltip.hover>{{model.request}}</pre>
                  <pre v-else class="bg-secondary">{{split_uri(model.request || '')}}</pre>
                </b-form-group>
              </b-col>
            </b-row>
            <hr v-if="has_get_parameter()">
            <b-row v-if="has_get_parameter()">
              <b-col sm="6">
                <b-form-group>
                  <b><label for="ph_seed" v-b-tooltip.hover>Request</label><br></b>
                  <pre class="bg-light p-4 rounded" style="overflow: scroll;" for="ph_seed" v-b-tooltip.hover>{{model.request}}</pre>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <b><label v-b-tooltip.hover>Request Parameter</label><br></b>
                  <table>
                    <thead>
                      <th class="border border-dark p-2">Name</th>
                      <th class="border border-dark p-2">Value</th>
                    </thead>
                    <tbody>
                      <tr v-for="(x, index) in parameter()" v-bind:key="index">
                        <td class="p-2">
                          {{x.key}}
                        </td>
                        <td class="p-2">
                          {{x.value}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <b-form-group>
                  <b><label for="ph_seed" v-b-tooltip.hover>Request Headers</label><br></b>
                  <pre class="bg-light p-4 rounded" style="overflow: scroll;" for="ph_seed" v-b-tooltip.hover>{{model.headers ? model.headers : 'no have data'}}</pre>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <center>
              Matched Information
              <!-- <span class="float-right">
                <span class="text-danger">*</span>
                Available options in the current policy ({{ model.target }}})
              </span> -->
            </center>
            <hr>
            <table v-if="is_error" class="table table-sm table-dark">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Message</th>
                  <th scope="col">Rule ID</th>
                  <!-- <th scope="col">Maturity</th>
                  <th scope="col">Accuracy</th> -->
                  <th scope="col">Response</th>
                  <th scope="col">Risk</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center">
                  <th scope="col" colspan="5">
                    The raw data was wrong, need to checking support
                  </th>
                </tr>
              </tbody>
            </table>
            <table v-else class="table table-sm table-dark text-center">
              <thead>
                <tr>
                  <th scope="col" rowSpan="2">#</th>
                  <th scope="col" rowSpan="2">Message</th>
                  <th scope="col" rowSpan="2" @click="info_threat = true" style="cursor:pointer">
                    Response & Threat
                    <span class="text-info">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </th>
                  <th v-if="!only_view" scope="col">
                    Manage
                    <span class="text-info" v-b-tooltip.hover :title="this.m_Title">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </th>
                  <th v-if="!only_view" scope="col">Now Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in (model.message.messages || [])" :key="index">
                  <th scope="row">
                    <b-link v-if="id" href="javascript:void(0)" @click="() => quick_search(row.details.ruleId)" v-b-tooltip.hover title="Displays the specified policy number For user policies, it is set flexibly depending on user settings (from 8,000,000 to 8,999,999)">
                      {{ row.details.ruleId ? row.details.ruleId : '-' }}
                    </b-link>
                    <span v-else>
                      {{ row.details.ruleId ? row.details.ruleId : '-' }}
                    </span>
                  </th>
                  <th scope="row">
                    <span class="text-info" v-if="row.details.i18n && row.details.i18n['EN'] && row.details.i18n['EN'].desc" @click="base_policy(row.details)">
                      <i class="fas fa-question-circle"></i>
                    </span>
                    <strong>{{detectInfo ? detectLog[index] : row.message}}</strong>
                    <!-- <strong>{{ row.details.i18n && row.details.i18n['EN'] ? (temp_i18n[row.details.i18n['EN'].desc] ? temp_i18n[row.details.i18n['EN'].desc] : row.details.i18n['EN'].desc) : (ruleI18n[row.details.ruleId] ? ruleI18n[row.details.ruleId]['EN'] : row.message) }}</strong> -->
                  </th>
                  <th scope="row">
                    <!-- <p>Policy ID : {{row.details.ruleId}} </p> -->
                    <!-- <span>{{row.details.ruleId}} </span>
                    <br> -->
                    <span>
                      <!-- {{row.details.tags}} -->
                      <!-- Response: -->
                      <b-badge v-if="row.is_info" variant="dark">-</b-badge>
                      <b-badge v-else-if="row.details.is_block" variant="danger">Block</b-badge>
                      <b-badge v-else variant="warning">Detect</b-badge>
                    </span>
                    <br>
                    <span>
                      <!-- Risk: -->
                      <span scope="row">
                        <b-badge :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(row.details.severity, 'variant')">
                          {{codes.WAF_SEVERITY_TO_DESC_EASY(row.details.severity, 'EN')}}
                        </b-badge>
                      </span>
                    </span>
                  </th>
                  <th v-if="!only_view && !loading" scope="row">
                    <b-button :disabled="version < 202207 ? (onOff[index] || check_custom(row.details)) : (row.now_status == codes.WAF_MODE_OFF.VALUE || check_custom(row.details))"  @click=" exception_info = {  applied : row.exception_list, msg : row.message, detail : row.details, agent_id : model.agent_id, is_exception : row.is_exception,  }; exception_info_modal_add = true; exception_info_modal_remove = false;" size="sm" style="width: fit-content; font-weight: bold;" variant="danger">
                      <span v-if="row.is_domain && !row.is_exception_domain" style="font-size:1.2rem; padding:0px; margin:0px;" class="text-danger">*</span>
                      Policy Off
                    </b-button>
                    <b-button :disabled="version < 202207 ? (!onOff[index] || check_custom(row.details)) : (row.now_status != codes.WAF_MODE_OFF.VALUE || check_custom(row.details))" @click=" exception_info = {  applied : row.exception_list, msg : row.message, detail : row.details, agent_id : model.agent_id, is_exception : row.is_exception }; exception_info_modal_remove = true; exception_info_modal_add = false;" size="sm" style="width: fit-content; font-weight: bold;" variant="warning">
                      <span v-if="row.is_domain && row.is_exception_domain" style="font-size:1.2rem;" class="text-danger">*</span>
                      Policy On
                    </b-button>
                  </th>
                  <th v-if="!only_view && row.now_status != null"  class="text-weight-bold">
                    {{codes.WAF_MODE_I18N(row.now_status, 'EN')}}
                  </th>
                  <th v-else  class="text-weight-bold">
                    -
                  </th>
                </tr>
              </tbody>
            </table>
            <hr>
            <b-button v-if="!id" size="sm" class="float-right" @click="list">List</b-button>
          </b-card>
        </b-col>
      </b-row>
      <!-- result modal -->
      <b-modal size="m" title="Description of detect"  class="modal-info" v-model="info_base_policy.is_show" hide-footer @ok="info_base_policy.is_show = false">
        provide detailed basis information for
        <hr>
        <pre  style="white-space: pre-wrap; word-break: keep-all;">
          {{info_base_policy.reason.match || '-'}}
        </pre>
        <hr>
        <pre  style="white-space: pre-wrap; word-break: keep-all;">
          {{info_base_policy.reason.data || '-'}}
        </pre>
      </b-modal>
      <!-- <b-modal size="m" title="XFF : X-Forwarded-For"  class="modal-info" v-model="info_xff" hide-footer @ok="info_xff = false">
        XFF: Displayed when proxy is set to X-Forwarded-For
      </b-modal> -->
      <!-- 정책 미사용 모달  -->
      <b-modal size="l" title="To disable a policy"  class="modal-success" v-model="exception_info_modal_add" @ok="add_white">
        <p>{{exception_policy_id}} Do you want to apply static jacks as unused?</p>
        <p>{{policy_domain()}} policy will change to unused and will be invisible in the detection log</p>
        <!-- <hr> -->
        <!-- <b-form-checkbox-group id="target_domain" v-model="exception_info.domain" name="target_domain">
          <b-form-checkbox v-for="x, index in get_domain_list" v-bind:key="index" :value="x" :disabled="check_disabled(x)">
            {{x}}
          </b-form-checkbox>
        </b-form-checkbox-group> -->
        <!-- <hr>
        <p>* 적용할 정책 대상을 선택해주세요</p> -->
      </b-modal>
      <b-modal size="m" title="To enable policy use"  class="modal-success" v-model="exception_info_modal_remove" @ok="remove_white">
        <p>Sets the currently unused policy to detection</p>
        <!-- <p v-if="exception_info.detail.i18n">{{exception_policy_id}} : {{ exception_info.detail.i18n['EN'].desc }} Change the policy to Detections</p> -->
         <!-- 변경 코드-->
         <p v-if="exception_info.detail.i18n">
          {{exception_policy_id}} : {{ exception_info.detail.i18n ? exception_info.detail.i18n['EN'].desc : exception_info.msg }} Change the policy to Detections
        </p>
        <p>You can check the detection log when you change to detection</p>
        <hr>
        <!-- <b-form-checkbox-group id="target_domain" v-model="exception_info.domain" name="target_domain">
          <b-form-checkbox v-for="x, index in get_domain_list" v-bind:key="index" :value="x" :disabled="check_disabled(x)">
            {{x}}
          </b-form-checkbox>
        </b-form-checkbox-group> -->
      </b-modal>
      <b-modal size="m" title="Threat"  class="modal-info" v-model="info_threat" hide-footer @ok="info_threat = false">
        Displays response type and risk
        <br>
        Response Type: Blocking (HTTP 403) and Detection (HTTP 200)
        <br>
        Risk : Displays the defined risk (risk, notification, information, customization, etc.)
      </b-modal>
    </div>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
